export default "__VITE_ASSET__Bb3Rb_hA__"